import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import BannerFormModal from './BannerFormModal';

export default function BannerFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/banners');
  };

  const handleSuccess = () => {
    history.push('/banners');
  };

  return (
    <AdminLayout title={id ? 'Edit Banner' : 'Create Banner'}>
      <BannerFormModal
        open={true}
        bannerId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
